module.exports = __webpack_public_path__ + "static/media/events.78375238.jpg";